import Add16 from '@carbon/icons-react/es/add/16';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'components/atoms/button';
import {
  EmptyState as Empty,
  EmptyStateContainer,
} from 'components/atoms/empty-state';

export const EmptyState = ({
  onResourceAdd,
}: {
  onResourceAdd: (value: boolean) => void;
}) => (
  <EmptyStateContainer>
    <Empty
      title={
        <FormattedMessage id="settings.integrations.sf.resource_mappings.empty.title" />
      }
      message={
        <FormattedMessage id="settings.integrations.sf.resource_mappings.empty.message" />
      }
    >
      <Button
        onClick={() => onResourceAdd(true)}
        iconPlacement="right"
        icon={<Add16 />}
        type="primary"
      >
        <FormattedMessage id="settings.integrations.sf.resource_mappings.add" />
      </Button>
    </Empty>
  </EmptyStateContainer>
);
